import * as React from 'react';
import { useAboutContextProvider } from '../../../Core/AboutContextProvider';
import { OnIgnoreEnter } from '../AnalyseApp';
import { ToWaveformNumeric, WaveformType } from '../interfaces/state';

interface DownloadButtonProps {
    sessionId: string;
    waveformType: string;
}

export const DownloadButton = (props: DownloadButtonProps) => {
    const { about } = useAboutContextProvider();

    const coughMarshalPlaybackRoot = `${about.CoughMarshalUri}/api/v1/playback`;
    const waveform = ToWaveformNumeric(props.waveformType as WaveformType);
    const filePath = `${coughMarshalPlaybackRoot}/download/${props.sessionId}/${waveform}`;

    return (
        <a href={filePath} className="btn btn-primary" onKeyDown={OnIgnoreEnter}>
            Download
        </a>
    );
}
